<div fxLayout="column" style="height: 100%">
   <div class="k-form-field sam-full-width sam-margin">
      <samweb-searchbar
         fxFlex="1 1 auto"
         [searchValue$]="searchValue$"
         (searchValueChanged)="searchTextChanged($event)"
      >
      </samweb-searchbar>
      <samweb-grid-filter
         [availableValues$]="availableFilters$"
         filterId="callHistoryFilter"
         (filteredValuesChanged)="filterChanged()"
         [brickInstanceId]="brickInstanceId"
      ></samweb-grid-filter>
      <button
         (click)="applyDataUpdate()"
         kendoButton
         kendoTooltip
         #dataUpdateTooltipDirective="kendoTooltip"
         [title]="'brick.brick_definitions.call_history_browser.update_available' | translate"
         [disabled]="!(newDataAvailable$ | async)"
         [class.k-state-active]="newDataAvailable$ | async"
         class="button-spacing"
      >
         <fa-icon [icon]="resyncIcon" [fixedWidth]="true"></fa-icon>
      </button>
      <button
         (click)="removeAllFilters()"
         kendoButton
         kendoTooltip
         [title]="'common.clear_all_filters' | translate"
         class="button-spacing"
      >
         <fa-icon [icon]="clearFilterIcon" [fixedWidth]="true"></fa-icon>
      </button>
   </div>

   <ng-template #tooltipTemplate let-anchor>
      <span>{{ anchor.nativeElement.innerText }}</span>
   </ng-template>
   <kendo-grid
      samwebPersistKendoGrid
      kendoTooltip
      #kendoGrid
      #cellTooltipDirective="kendoTooltip"
      scrollable="virtual"
      showOn="none"
      filter=".k-grid td"
      kendoGridSelectBy="uniqueCallId"
      [skip]="skip$ | async"
      [pageSize]="gridPageSize"
      [height]="gridDisplayHeight"
      [rowHeight]="gridRowHeight"
      [data]="callHistoryData$ | async"
      [columnMenu]="true"
      [sortable]="false"
      [resizable]="true"
      [reorderable]="true"
      [trackBy]="trackBy"
      [selectedKeys]="selectedKeys$ | async"
      [selectable]="{
         mode: 'single'
      }"
      [tooltipTemplate]="tooltipTemplate"
      (selectionChange)="selectionChanged($event)"
      (mouseover)="showTooltip($event)"
      (mouseout)="hideTooltip()"
      (cellClick)="kendoCellClick($event)"
      (dblclick)="onRowDoubleClick($event)"
      fxFlex="1 1 auto"
   >
      <ng-container *samwebVar="selectedKeys$ | async as selectedKeys">
         <kendo-grid-column
            [title]="
               'wa_historybrowser_type'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.type'
                  | async
            "
            field="callType"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-conversation-type
                  [conversationTypeAsSamwinValue]="dataItem.conversationType"
                  [conversationStatusTypeAsSamwinValue]="dataItem.state"
                  [conversationIci]="dataItem.ici"
               ></samweb-conversation-type>
               {{ dataItem.ici | iciText }}
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_historybrowser_caller'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.peer'
                  | async
            "
            field="peer"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-highlight-text
                  [searchValue]="currentSearchValue"
                  [primaryText]="dataItem.peerName"
                  [secondaryText]="dataItem.peerId"
                  [isCallable]="isCallable(dataItem.peerId, dataItem?.conversationType)"
                  (click)="
                     selectedKeys.indexOf(dataItem.uniqueCallId) > -1 &&
                        isCallable(dataItem.peerId, dataItem?.conversationType) &&
                        call(dataItem.peerId)
                  "
               ></samweb-highlight-text>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            [title]="
               'wa_historybrowser_forwardingPeer'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.forwarding_peer'
                  | async
            "
            field="forwardingPeer"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-highlight-text
                  [searchValue]="currentSearchValue"
                  [primaryText]="dataItem.forwardingPeerName"
                  [secondaryText]="dataItem.forwardingPeerId"
                  [isCallable]="isCallable(dataItem.forwardingPeerId, dataItem?.conversationType)"
                  (click)="
                     selectedKeys.indexOf(dataItem.uniqueCallId) > -1 &&
                        isCallable(dataItem.forwardingPeerId, dataItem?.conversationType) &&
                        call(dataItem.forwardingPeerId)
                  "
               ></samweb-highlight-text>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_historybrowser_transferTarget'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.transfer_target'
                  | async
            "
            field="transfer_target"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-highlight-text
                  [searchValue]="currentSearchValue"
                  [primaryText]="dataItem.targetPeerName"
                  [secondaryText]="dataItem.targetPeerId"
                  [isCallable]="isCallable(dataItem.targetPeerId, dataItem?.conversationType)"
                  (click)="
                     selectedKeys.indexOf(dataItem.uniqueCallId) > -1 &&
                        isCallable(dataItem.targetPeerId, dataItem?.conversationType) &&
                        call(dataItem.targetPeerId)
                  "
               ></samweb-highlight-text>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="skill"
            [title]="
               'wa_historybrowser_skillSortText'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.skill'
                  | async
            "
            [style]="{ 'line-height': '100%' }"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-skill-short-info
                  [searchValue]="currentSearchValue"
                  [skillConfiguration]="dataItem.queueId | skillIdToShortSkillInfo$ | async"
               ></samweb-skill-short-info>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="memo"
            [title]="
               'wa_historybrowser_memo'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.memo'
                  | async
            "
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-call-memo
                  [callHistoryForCallId]="dataItem.uniqueCallId"
                  [origMemoValue]="dataItem.memo"
                  [searchValue]="currentSearchValue"
               ></samweb-call-memo>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            [title]="
               'wa_historybrowser_timestamp'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.timestamp'
                  | async
            "
            field="callTime"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-call-time
                  [timestamp]="dataItem.timestamp"
                  [conversationStatusTypeAsSamwinValue]="dataItem.state"
                  [showPrimaryFullDateFormat]="showPrimaryFullDateFormat$ | async"
               ></samweb-call-time>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="agent"
            [title]="
               'wa_historybrowser_agentSortText'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.agent'
                  | async
            "
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-call-agent
                  [callHistoryForCallId]="dataItem.uniqueCallId"
                  [searchValue]="currentSearchValue"
                  [origAgentValue]="dataItem.targetUserInfo?.displayName"
               ></samweb-call-agent>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="progressState"
            [title]="
               'wa_historybrowser_progressState'
                  | customColumnName: 'brick.brick_definitions.call_history_browser.columns.progress_state'
                  | async
            "
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-call-progress-info
                  [callHistoryForCallId]="dataItem.uniqueCallId"
                  [originalAgentId]="dataItem.targetUserInfo?.id"
               ></samweb-call-progress-info>
            </ng-template>
         </kendo-grid-column>

         <ng-template kendoGridNoRecordsTemplate>
            <samweb-grid-wait-for-data
               [brickInstanceIdFroLongRunningCheck]="brickInstanceId"
               [disableInfinityScrollDuringLongRunningCategories]="['CALL_HISTORY']"
            ></samweb-grid-wait-for-data>
         </ng-template>
      </ng-container>
   </kendo-grid>
   <div *ngIf="selectedFilters.length > 0" class="call-history-filter">
      <fa-icon [icon]="statusBarFilterIcon"></fa-icon>
      <span *ngFor="let selectedFilter of selectedFilters; last as isLast">
         {{ selectedFilter.translationKey | translate }}<span *ngIf="!isLast">, </span>
      </span>
   </div>
</div>
